import script from "./AccessDenied.vue?vue&type=script&setup=true&lang=js"
export * from "./AccessDenied.vue?vue&type=script&setup=true&lang=js"

import "./AccessDenied.vue?vue&type=style&index=0&id=18eb0298&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18eb0298"]])

export default __exports__